export type DirectoryPickerHandle = FileSystemDirectoryHandle | FileSystemFileHandle;

export interface DirectoryPickerDirectoryHandle {
  readonly kind: "directory";
  readonly name: string;
  entries(): AsyncIterableIterator<[string, DirectoryPickerHandle]>;
  requestPermission?(descriptor: { mode: "read" }): Promise<PermissionState>;
}

export interface DirectoryPickerFileHandle {
  readonly kind: "file";
  readonly name: string;
  getFile(): Promise<File>;
}

export function getShowDirectoryPicker():
  | ((options?: { mode?: "read" }) => Promise<DirectoryPickerDirectoryHandle>)
  | undefined {
  return (window as Window & { showDirectoryPicker?: () => Promise<DirectoryPickerDirectoryHandle> })
    .showDirectoryPicker;
}
